module.exports = __webpack_public_path__ + "img/plus-circle.57d718f5.svg";